import { AimOutlined } from '@ant-design/icons'
import { Avatar, List } from 'antd'
import { groupBy, partition } from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { UserHoverCard } from '@/components'
import { useGetUserOkrQuery } from '@/generated/graphql'
import { routes } from '@/routes'

import { UserInfoSectionLayout } from './user-info-section-layout/user-info-section-layout.component'
import { UserInfoProps } from './user-info.interface'
import s from './user-info.module.less'

export const UserInfoOKR: React.FC<UserInfoProps> = ({ userId }) => {
  const { t } = useTranslation()

  const { data } = useGetUserOkrQuery({
    variables: {
      userId,
    },
  })

  const userInfo = data?.user

  const [viewerObjectives, otherObjectives] = partition(
    userInfo?.objectivesFeature?.objectives.slice() || [],
    (o) => o.user?.iamId === userId
  )

  const groupedOtherObjectives = groupBy(otherObjectives, 'user.iamId')
  Object.keys(groupedOtherObjectives).forEach((key) => {
    viewerObjectives.push(...groupedOtherObjectives[key])
  })

  const objectives = viewerObjectives.slice(0, 5)

  const cycle = userInfo?.currentCycle || { name: '', cycleId: 1 }

  const okrs = (
    <List
      className={s.okrList}
      dataSource={objectives}
      renderItem={(objective) => (
        <List.Item>
          <List.Item.Meta
            title={
              <a
                style={{ color: '#48bbb5' }}
                href={`https://okr.agoralab.co/okr/overview?cycle=${cycle.cycleId}&selectKey=${objective.department?.id}`}
                target='_blank'
                rel='noopener noreferrer'
              >
                {objective.name}
              </a>
            }
            description={
              <div className={s.description}>
                <span className={s.okrDepartment}>{`部门：${objective.department?.name || ''}`}</span>
                {objective.user && (
                  <div className={s.okrOwner}>
                    <span>{'负责人：'}</span>
                    <UserHoverCard email={objective.user?.email}>
                      <Link to={routes.users.page(objective.user?.email || '')} className={s.okrOwnerLink}>
                        <Avatar size={20} style={{ marginTop: 2 }} src={objective.user?.avatar} />
                        <span style={{ marginLeft: 4, whiteSpace: 'nowrap' }}>
                          {objective.user.name + (objective.user.alias ? `(${objective.user.alias})` : '')}
                        </span>
                      </Link>
                    </UserHoverCard>
                  </div>
                )}
              </div>
            }
          ></List.Item.Meta>
        </List.Item>
      )}
    />
  )

  if (objectives.length === 0) {
    return null
  }

  const objectivesAndProjectsPart = <div className={s.objectiveProject}>{objectives.length > 0 && okrs}</div>

  return (
    <UserInfoSectionLayout title={t('user.info.objectives')} icon={<AimOutlined />}>
      {objectivesAndProjectsPart}
    </UserInfoSectionLayout>
  )
}
